import { Button, InputBase, TextField } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../contexts/user.context";
import Box from "@mui/material/Box";
import { makeStyles } from "@material-ui/styles";
import Form from "react-bootstrap/Form";

import "./Login.css";
import { useTranslation } from "react-i18next";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState("en");

  const changeLanguage = (event) => {
    setSelectedLang(event.target.value);
    i18n.changeLanguage(event.target.value);
    //  console.log('language:', event.target.value);
  };

  // console.log('118n:', i18n);

  // We are consuming our user-management context to
  // get & set the user details here
  const { user, fetchUser, emailPasswordLogin } = useContext(UserContext);

  // We are using React's "useState" hook to keep track
  //  of the form values.
  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  // This function will be called whenever the user edits the form.
  const onFormInputChange = (event) => {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
  };

  // This function will redirect the user to the
  // appropriate page once the authentication is done.
  const redirectNow = () => {
    const redirectTo = location.search.replace("?redirectTo=", "");
    navigate(redirectTo ? redirectTo : "/moduleSummary");
  };

  // Since there can be chances that the user is already logged in
  // but whenever the app gets refreshed the user context will become
  // empty. So we are checking if the user is already logged in and
  // if so we are redirecting the user to the home page.
  // Otherwise we will do nothing and let the user to login.
  const loadUser = async () => {
   // console.log(":logged in user:", user.providerType);
    if (!user && user.providerType === "local-userpass") {
      const fetchedUser = await fetchUser();
      if (fetchedUser) {
        // Redirecting them once fetched.
        redirectNow();
      }
    }
  };

  // This useEffect will run only once when the component is mounted.
  // Hence this is helping us in verifying whether the user is already logged in
  // or not.
  useEffect(() => {
    loadUser(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // This function gets fired when the user clicks on the "Login" button.
  const onSubmit = async (event) => {
    try {
      // Here we are passing user details to our emailPasswordLogin
      // function that we imported from our realm/authentication.js
      // to validate the user credentials and login the user into our App.
      const user = await emailPasswordLogin(form.email, form.password);

      // console.log("Usr:", user);
      if (user) {
        redirectNow();
      }
    } catch (error) {
      //  alert(error);
      alert("Entered User Id/Password is Wrong...");
    }
  };
  const useStyles = makeStyles((theme) => ({
    textField: {
      border: "1px solid #209F85",
      borderRadius: "30px",
      backgroundColor: "#FFFFFF",
    },
    inputbase: {
      border: "1px solid #209F85",
      borderRadius: "30px",
      backgroundColor: "#FFFFFF",
      height: "7vh",
    },
  }));
  const classes = useStyles();
  return (
    <>
      <div style={{ background: "#EBEBEB", height: "100vh" }}>
        <div style={{ paddingTop: "1.5rem" }}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              maxWidth: "350px",
              margin: "auto",
              backgroundColor: "#ffffff",
              paddingLeft: "10pt",
              paddingRight: "10pt",
              borderRadius: "10pt",
              // marginTop: "20pt",
              minHeight: "400px",
            }}
          >
            <h1
              style={{
                fontSize: "1.5rem",
                textAlign: "center",
                color: "#1D5A90",
                marginTop: "2rem",
                marginBottom: "2rem",
              }}
            >
              Log In
            </h1>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              {/* <Form.Label>Email address</Form.Label> */}
              <Form.Control
                id="inputID"
                placeholder="Email"
                label="Email"
                type="email"
                variant="outlined"
                name="email"
                value={form.email}
                onChange={onFormInputChange}
                style={{
                  borderRadius: "50px",
                  height: "7vh",
                  border: "1px solid #209F85",
                }}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              {/* <Form.Label>Password</Form.Label> */}
              <Form.Control
                id="inputID"
                label="Password"
                type="password"
                variant="outlined"
                name="password"
                value={form.password}
                onChange={onFormInputChange}
                placeholder="Password"
                style={{
                  borderRadius: "50px",
                  height: "7vh",
                  border: "1px solid #209F85",
                }}
              />
            </Form.Group>

            {/* <div onChange={changeLanguage}>
            <label className="mr10"><input type="radio" value="en" name="language" checked={selectedLang === 'en'} /> English</label>
            <label ><input type="radio" value="marathi" name="language" checked={selectedLang === 'marathi'} /> Marathi</label>
          </div> */}

            <div class="container" style={{ marginTop: "-0.5rem" }}>
              <div class="row">
                <div
                  class="col"
                  style={{
                    textAlign: "left",
                    color: "#209F85",
                    fontSize: "0.8rem",
                    fontWeight: "bold",
                  }}
                >
                  New user? <Link to="/signup">Sign Up</Link>
                </div>
                <div
                  class="col"
                  style={{
                    color: "#1F448F",
                    fontSize: "0.8rem",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  Forgot Password ?
                </div>
              </div>
            </div>

            <Button
              variant="contained"
              style={{
                background: "#1D5A90",
                borderRadius: 50,
                marginTop: "3rem",
                textTransform: "none",
              }}
              onClick={onSubmit}
            >
              Login
            </Button>
            <div
              style={{
                textAlign: "center",
                marginTop: "2rem",
                marginBottom: "2rem",
              }}
            >
              <img
                src={require("../assets/logo.png")}
                className="img-fluid"
                style={{ width: "25%" }}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
